<template lang="pug">
div.pad
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required|cnpj", v-slot="{ errors }", :name="nomeAba + '/CNPJ'")
        app-label(label="CNPJ:", :required="true")
        el-input.input(
          name='cnpj'
          v-model="pessoaJuridica.cnpj",
          v-mask="'##.###.###/####-##'",
          :class="{'erro' : errors.length}",
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Razão social'")
        app-label(label="Nome/Razão Social", :required="true")
        el-input.input(
          name='razaoSocial'
          v-model="pessoaJuridica.razaoSocial",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event,'razaoSocial')"
        )
        span.help.erro {{ errors[0] }}

  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(rules="required|cpf", v-slot="{ errors }", :name="nomeAba + '/CPF do presidente da associação/empresa'")
        app-label(label="CPF do presidente da associação/empresa:", :required="true")
        el-input.input(
          name='cpfPresidenteAssociacao'
          v-model="pessoaJuridica.presidenteAssociacao.cpf",
          v-mask="'###.###.###-##'",
          :class="{'erro' : errors.length}",
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="16")
      validation-provider(rules="required", v-slot="{ errors }", :name="nomeAba + '/Nome do presidente da associação/empresa'")
        app-label(label="Nome do presidente da associação/empresa", :required="true")
        el-input.input(
          name='nomePresidenteAssociacao'
          v-model="pessoaJuridica.presidenteAssociacao.nome",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'presidenteAssociacao','nome')"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/presidenteAssociacao/Tipo de documento'")
        app-label(label="Tipo de documento:", :required="false")
        el-select.input(
          class="select",
          name='Tipo de documento'
          v-model="pessoaJuridica.presidenteAssociacao.tipoDocumento",
          value-key="codigo"
          no-match-text="Nenhum tipo de documento encontrado",
          placeholder="Selecione",
          clearable,
          filterable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="(item, index) in tipoDocumentos",
            :key="index",
            :label="item",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(v-if="pessoaJuridica.presidenteAssociacao.tipoDocumento == 'OUTROS'" :span="8")
      validation-provider(:rules="true", v-slot="{ errors }", :name="nomeAba + '/presidenteAssociacao/OutrosTipoDocumento'")
        app-label(label="Outros:", :required="true")
        el-input.input(
          name='Outros',
          maxlength="30",
          v-model="pessoaJuridica.presidenteAssociacao.outrosTipoDocumento",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event,'presidenteAssociacao', 'outrosTipoDocumento')"
        )
        span.help.erro {{ errors[0] }}
  el-row.labelDiv(:gutter="30")
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/presidenteAssociacao/RG'")
        app-label(label="RG:", :required="false")
        el-input.input(
          name='RG',
          maxlength="30",
          v-model="pessoaJuridica.presidenteAssociacao.rg",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event,'presidenteAssociacao', 'rg')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/presidenteAssociacao/Órgão Expedidor'",  mode="lazy")
        app-label(label="Órgão expedidor:", :required="false")
        el-select.input(
          name='Órgão expedidor',
          class="select",
          no-match-text="Nenhum orgão encontrado",
          placeholder="Selecione",
          v-model="pessoaJuridica.presidenteAssociacao.orgaoExpedidor.nome",
          value-key="id",
          filterable,
          clearable,
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="orgaoExpedidor in orgaosExpedidores",
            :key="orgaoExpedidor.id",
            :label="orgaoExpedidor.nome",
            :value="orgaoExpedidor.nome"
          )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", :name="nomeAba + '/presidenteAssociacao/UF do RG'",  mode="lazy")
        app-label(label="UF do RG:", :required="false")
        el-select.input(
          name='UF do RG'
          class="select",
          no-match-text="Nenhuma UF encontrada",
          placeholder="Selecione",
          v-model="pessoaJuridica.presidenteAssociacao.orgaoExpedidor.estado"
          clearable,
          filterable,
          :disabled="!pessoaJuridica.presidenteAssociacao.orgaoExpedidor.nome",
          :class="{'erro' : errors.length}"
          @change="setOrgaoCodigo"
        )
          el-option(
            v-for="estado in estadosBr",
            :key="estado.codigo",
            :label="estado.nome",
            :value="estado.codigo"
          )
        span.help.erro {{ errors[0] }}

</template>
<script>
import AppLabel from './AppLabel'
import AppInputTelefone from '@/components/AppInputTelefone'
import estadosBr from '@/constants/estados'
import { mapActions } from 'vuex'
const { tipoDocumentos } = require('@/utils/' +
  process.env.ESTADO +
  '/regrasCentral').default

export default {
  components: {
    AppLabel,
    AppInputTelefone
  },

  props: {

    pessoa: {
      type: Object,
      required: true
    },

    nomeAba: {
      type: String,
      required: true
    },

    observer: {
      required: true
    }
  },

  data () {
    return {
      tipoDocumentos,
      estadosBr,
      orgaosExpedidores: []
    }
  },
  mounted () {
    this.setOrgaosExpeditores()
  },
  methods: {
    ...mapActions({
      getOrgaosExpedidores: 'orgaosExpedidores/getItems',
      getOrgaosExpedidoresByUf: 'orgaosExpedidores/getOrgaosExpedidoresByUf'
    }),
    async setOrgaosExpeditores () {
      this.orgaosExpedidores = await this.getOrgaosExpedidores()
      this.orgaosExpedidores.forEach(element => {
        element.nome = element.nome.toUpperCase()
      })
    },

    setOrgaoCodigo () {
      this.pessoaJuridica.presidenteAssociacao.orgaoExpedidor.codigo = this.orgaosExpedidores.find(
        orgao => orgao.nome === this.pessoaJuridica.presidenteAssociacao.orgaoExpedidor.nome
      ).codigo
      this.setIdOrgaoExpedidor(this.pessoaJuridica.presidenteAssociacao.orgaoExpedidor.estado)
    },
    async setIdOrgaoExpedidor (uf) {
      if (uf) {
        const orgaosExpedidoresUfSelecionado = await this.getOrgaosExpedidoresByUf(uf)
        if (orgaosExpedidoresUfSelecionado?.length) {
          this.pessoaJuridica.presidenteAssociacao.orgaoExpedidor.id = orgaosExpedidoresUfSelecionado.find(
            orgao => orgao.codigo === this.pessoaJuridica.presidenteAssociacao.orgaoExpedidor.codigo
          ).id
        }
      }
    },
    toUppercase (valor, primeiro, segundo) {
      if (segundo) {
        this.pessoaJuridica[primeiro][segundo] = valor.toUpperCase()
        return
      }
      this.pessoaJuridica[primeiro] = valor.toUpperCase()
    }
  },
  computed: {
    pessoaJuridica () {
      return this.pessoa.pessoaJuridica
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

.marginTop {
  margin-top: 5px;
}

.select {
  width: 100%;
}

/deep/ .tag-app-input i{
  color: #9BA0A9 !important;
}

/deep/ .tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

/deep/ .el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}

/deep/ .style {
  color: #9ba0a9 !important;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppPessoaJuridicaProcessoFisico.vue